import { Dispatch } from 'redux';
import { fetchMoreArticles } from '../../../services/pilotServiceApiProvider';
import { getImagesCdnHost, getLocale, getMidnightInTimeZone, getTimeZone } from '../../config/config.selectors';
import { getRecommendationsNextByKey } from './postPage.selectors';
import { RecommendationNames } from './postPage.reducer';
import { PostPageAppState } from '../../initialStateRegistration';
import { receivePostsSuccessfully, receivePostsUnsuccessfully, requestPosts } from '../loadMore.actions';

export interface InjectArticleBlockByIndexParams {
    html: string;
    dataId: string;
    index: number;
    script?: string;
}

export type InjectArticleBlockByIndexArrayParams = Array<InjectArticleBlockByIndexParams>

export const fetchNextPosts = (key: RecommendationNames) => {
  return (dispatch: Dispatch, getState: () => PostPageAppState) => {
    dispatch(requestPosts());
    try {
      const state = getState();
      const endpoint = getRecommendationsNextByKey(key)(state);
      const imageCDNHost = getImagesCdnHost(state);
      const locale = getLocale(state);
      const timeZone = getTimeZone(state);
      const midnightInTimeZone = getMidnightInTimeZone(state);
      return fetchMoreArticles(endpoint)
        .then(json => dispatch(receivePostsSuccessfully(json, key, imageCDNHost, midnightInTimeZone, timeZone, locale)))
        .catch(error => dispatch(receivePostsUnsuccessfully(error)));
    } catch (e) {
      dispatch(receivePostsUnsuccessfully(e));
      return null;
    }
  };
};

const createInjectedBlock = ({ index, html, dataId, script }: InjectArticleBlockByIndexParams) => ({
    index,
    block: {
        type: 'injectedBlock',
        html,
        dataId,
        script,
    },
});

export const INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY = 'inject article block by index array';
export const injectArticleBlockByIndexArray = (params: InjectArticleBlockByIndexArrayParams) => {
    return {
        type: INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
        blocks: params.map(createInjectedBlock),
    };
};
